import { api } from "../api";

export default async function handleCallback(
  provider: string,
  query: string
): Promise<boolean> {
  try {
    const { status, data } = await api.get(
      `/auth/login/${provider}/callback${query}`
    );

    if (status === 200) {
      const token = data.data.token;

      localStorage.setItem("auth_token", token);
      localStorage.setItem(
        "auth_token_created_at",
        new Date().getTime().toString()
      );

      return true;
    }

    return false;
  } catch (err) {
    console.log(err);

    return false;
  }
}
